<template>
  <div class="cpntent-wrap">
    <div class="clearFix top-btn-box lk-content">
      <div class="floatr">
        <el-button type="primary" plain @click="addCart(dataSource.id)">加入购物车</el-button>
        <el-button type="primary" @click="linkToCart">查看购物车</el-button>
      </div>
    </div>
    <div class="product-box lk-content">
      <div class="clearFix">
        <div class="floatl product-left-font">
          <div class="product-box-top product-content-box">
            <div class="product-name">{{dataSource.productName}}</div>
            <div class>
              <span class="product-label">订货号：</span>
              <span class="color333">{{dataSource.orderNo}}</span>
            </div>
            <div class>
              <span class="product-label">产品分类：</span>
              <span
                v-for="(item,index) in currentProducttype"
                @click="linkToProductTypeGoods(item.id)"
                :key="item.id"
              >
                <span v-if="index"></span>
                <span class="linkType">{{item.name}}</span>
              </span>
            </div>
            <div class>
              <span class="product-label">应用分类：</span>
              <span
                v-for="(item,index) in currentApplicationtype"
                @click="linkToApplicationTypeGoods(item.id)"
                :key="item.id"
              >
                <span v-if="index">></span>
                <span class="linkType">{{item.name}}</span>
              </span>
            </div>
          </div>
          <div class="product-box-center product-content-box">
            <div class="product-label">商品参数：</div>
            <div>
              <span>规格：</span>
              <span v-if="dataSource.specifications">{{dataSource.specifications}}</span>
            </div>
            <div>
              <span>主计量单位：</span>
              <span v-if="dataSource.packaging">{{dataSource.packaging}}</span>
            </div>
            <div>
              <span>运保温度：</span>
              <span v-if="dataSource.temperatureOperational">{{dataSource.temperatureOperational}}&nbsp;°C</span>
            </div>
            <div>
              <span>到货周期：</span>
              <span v-if="dataSource.goodsCycle">{{dataSource.goodsCycle}}&nbsp;天</span>
            </div>
            <div>
              <span>商品有效期：</span>
              <span v-if="inventory && inventory.periodValidity">{{inventory.periodValidity}}&nbsp;天</span>
            </div>
            <div>
              <span>标准价：</span>
              <span v-if="userId">
                <span v-if="dataSource.isPay == null || dataSource.isPay == 0">
                  ￥{{dataSource.pymoney}}
                </span>
                <span v-else-if="dataSource.isPay != null || dataSource.isPay != 0">询价</span>
              </span>
              <span v-else-if="!userId">
                <router-link to="/login">登录</router-link>后可查看价格
              </span>
            </div>
            <div>
              <span>会员价：</span>
              <span class="sum-font" v-if="userId">
                <span v-if="dataSource.isPay == null || dataSource.isPay == 0">
                  ￥{{dataSource.membersPyMoney}}
                </span>
                <span v-else-if="dataSource.isPay != null || dataSource.isPay != 0">询价</span>
              </span>
              <span v-else>
                <router-link to="/login">登录</router-link>后可查看价格
              </span>
            </div>
            <div>
              <span>积分：</span>
              <span class="sum-font" v-if="userId">{{dataSource.integral}}</span>
              <span v-else>
                <router-link to="/login">登录</router-link>后可查看价格
              </span>
            </div>
          </div>
          <div class="product-content-box">
            <div class="product-label">运费与支付说明：</div>
            <div>1. 含干冰类产品有运费；</div>
            <div>2. 必须现金付款或有信用额度的会员才可以直接发货，否则需要等待现金付款信息。</div>
          </div>
        </div>
        <el-carousel height="500px">
          <img style="width: 550px;height: 500px;"
            v-if="!dataSource.productDetailsImg && !dataSource.brandUrl"
            src="http://39.107.228.160:9000/static/img/cytech_logo.73361c2.png"
            @click="Jump(item.id)"
            alt="商品图"
          >
          <img style="width: 550px;height: 500px;" v-else-if=" !dataSource.productDetailsImg && dataSource.brandUrl" :src="`${$base.urlImage}${dataSource.brandUrl}`" @click="Jump(item.id)" alt="商品图">
         
          <el-carousel-item v-else v-for="item in productDetailsImg" :key="item">
            <img :src="item" style="width: 550px;height: 500px;" alt>
          </el-carousel-item>
          
        </el-carousel>
      </div>
      <div class="product-content-box">
        <div class="product-label">描述：</div>
        <div v-if="description && description.describtion" v-html="description.describtion"></div>
        <div class="product-label">原厂资料：</div>
        <div v-if="description && description.originalData" v-html="description.originalData"></div>
      </div>
      <div class="clearFix product-content-box product-half-content">
        <div class="floatl">
          <div class="product-label">详细说明：</div>
          <div class="label-box" v-for="item in detailedinfo" :key="item.id">
            <div>
              <span>{{item.key}}</span>
              <span>{{item.value}}</span>
            </div>
          </div>
        </div>
        <div class="floatr">
          <div class="product-label">说明书：</div>
          <div>
            <a
              v-if="instruction && instruction.hyperlinked"
              :href="instruction.hyperlinked"
              target="_blank"
            >{{instruction.name}}</a>

            <a
              v-else-if="instruction && instruction.word"
              :href="localImgUrl(instructionsa)"
              target="_blank"
            >{{instruction.name}}</a>
            <a
              v-else-if="instruction && instruction.hyperlinked && instruction.word"
              target="_blank"
            >{{instruction.name}}</a>
          </div>

          <div class="product-label">参考文献：</div>
          <div v-for="(item,index) in reference" :key="item.id">
            <a
              :href="item.hyperlinked || localImgUrl(item.url)"
              v-if="instruction && item.url"
              target="_blank"
            >{{index+1}}.{{item.name}}</a>
          </div>
        </div>
      </div>
      <div class="product-content-box clearFix">
        <div class="product-label">本产品可用于的实验：</div>
        <div class="clearFix">
          <div class="floatl product-left-label">实验描述：</div>
          <div
            class="floatl"
            v-if="description && description.experimentDescribed"
            v-html="description.experimentDescribed"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { post, get, postRequest } from "@/axios/index";
export default {
  data() {
    return {
      productDetailsImg: [],
      //商品信息
      dataSource: "",
      //参考文献
      reference: [
        {
          hyperlinked: ""
        }
      ],
      //用户说明书
      instruction: {
        hyperlinked: ""
      },
      //产品说明（描述，原厂资料）
      instructionsa: "",
      description: "",
      //详细说明
      detailedinfo: [],
      userId: "",
      //应用分类
      applicationtype: "",
      //产品分类
      productype: "",
      //当前应用分类
      currentApplicationtype: [],
      //当前产品分类
      currentProducttype: [],
      //商品库存
      inventory:""
    };
  },
  methods: {
    addCart(items) {
      if (this.userId) {
        //判断用户是否已登录
        // 跳转购物车
        postRequest("/stkshoppingcenterinfo/insertstkshoppingcenterinfo", {
          productId: items,
          userRegisterId: this.userId,
          productNumber: 1
        })
          .then(res => {
            console.log("添加结果res=", res);
             if(res.data.code == '201'){
              this.$message({
                  type: "error",
                  message: res.data.msg
                });
            }
            if(res.data.code == '200'){
              this.$confirm("商品已成功加入购物车", "提示", {
                confirmButtonText: "继续购物",
                cancelButtonText: "查看购物车",
                type: "success",
                center: true
              })
                .then(() => {
                  console.log("点击继续购物");
                })
                .catch(() => {
                  console.log("点击查看购物车");
                  this.$router.push({
                    path: "/pc/order-cart"
                  });
                });
            }
          })
          // .catch(err => {
          //  this.$message({
          //     type: "error",
          //     message: err.message
          //   });
          //   // console.log("添加失败err=", err);
          // });
      } else {
        //没有登录
        this.$router.push({
          path: "/login"
        });
      }
    },
    linkToCart() {
      this.$router.push("/pc/order-cart");
    },
    //递归产品应用分类
    traverseTreeProduct(node) {
      if (!node) {
        return;
      }
      this.currentProducttype.push({
        name: node.name,
        id: node.id
      });
      if (node.children && node.children.length > 0) {
        var i = 0;
        for (i = 0; i < node.children.length; i++) {
          console.log(node.name, "node.name");
          this.traverseTreeProduct(node.children[i]);
        }
      }
      console.log(
        JSON.stringify(this.currentProducttype),
        "currentProducttype"
      );
    },
    //递归遍历应用分类
    traverseTreeApplication(node) {
      if (!node) {
        return;
      }
      this.currentApplicationtype.push({
        name: node.name,
        id: node.id
      });
      if (node.children && node.children.length > 0) {
        var i = 0;
        for (i = 0; i < node.children.length; i++) {
          console.log(node.name, "node.name");
          this.traverseTreeApplication(node.children[i]);
        }
      }
      console.log(
        JSON.stringify(this.currentApplicationtype),
        "currentApplicationtype"
      );
    },
    linkToApplicationTypeGoods(id) {
      //按应用分类筛选
      this.$router.push({
        path: "/pc/product",
        query: {
          appTypeFuzzyId: id
        }
      });
    },
    linkToProductTypeGoods(id) {
      //按产品分类筛选
      this.$router.push({
        path: "/pc/product",
        query: {
          proTypeFuzzyId: id
        }
      });
    }
  },
  mounted() {
    //获取商品数据
    get("/stkproductinfo/getbyid", {
      id: this.$route.query.id
    }).then(
      response => {
        const {
          data: {
            result: { productDetailsImg }
          }
        } = response;
        this.productDetailsImg = JSON.parse(productDetailsImg);
        let oKeyWords = document.createElement("meta");
        oKeyWords.name = "keywords";
        oKeyWords.content = response.data.result.meta;
        document.head.appendChild(oKeyWords);
        this.dataSource = response.data.result;
        console.log('商品参数=====>>>',this.dataSource);
        this.detailedinfo = JSON.parse(response.data.result.productDetailed);
        //获取产品分类
        get("/stkbasicdict/getlistbyproductId", {
          productId: this.dataSource.id
        }).then(
          responseIns => {
            this.producttype = responseIns.data.result[0];
            this.traverseTreeProduct(this.producttype);
            console.log(this.producttype, "producttype");
          },
          // err => {
          //   this.$message({
          //     type: "error",
          //     message: err
          //   });
          // }
        );
        //获取应用分类
        get("/stkapplicationtype/getlistbyproductId", {
          productId: this.dataSource.id
        }).then(responseIns => {
          this.applicationtype = responseIns.data.result[0];
          this.traverseTreeApplication(this.applicationtype);
          console.log(this.applicationtype, "applicationtype");
        });
        //获取产品说明（描述，原厂资料）
        get("/stkproductdescriptioninfo/getbyid", {
          id: this.dataSource.id
        }).then(
          responseIns => {
            this.description = responseIns.data.result;
            console.log(this.description, "description");
          },
          // err => {
          //   this.$message({
          //     type: "error",
          //     message: err
          //   });
          // }
        );
        //获取用户说明书
        get("/stkproductinstructionsinfo/getlistbyproductid", {
          productId: this.dataSource.id
        }).then(
          responseIns => {
            this.instruction = responseIns.data.result;
            if (!this.instruction) return;
            var obj = responseIns.data.result.word.lastIndexOf("/");
            console.log(responseIns.data.result.word.substr(obj + 1));
            console.log(responseIns.data.result.word.substr(obj - 1));

            var name = responseIns.data.result.word.substr(obj + 1);
            var ind = "/api/management/file/download?word=";
            var url = ind + name;
            this.instructionsa = url;
            console.log(this.instructionsa);
          },
          // err => {
          //   this.$message({
          //     type: "error",
          //     message: err
          //   });
          // }
        );
        //获取参考文献
        get("/stkproductreferenceinfo/getlistbyproductid", {
          productId: this.dataSource.id
        }).then(
          ({ data: { result } }) => {
            if (!result.length) return;
            this.reference = result;
          },
          // err => {
          //   this.$message({
          //     type: "error",
          //     message: err
          //   });
          // }
        );
        //获取产品库存
        get("/stkproductinventory/getbyproductid", {
          productId: this.dataSource.id
        }).then(({ data: { result } }) => {
          this.inventory = result;
          // this.inventory.dateProduction = this.$moment(result.dateProduction).format("YYYY-MM-DD")
          // this.inventory.expiryDate = this.$moment(result.expiryDate).format("YYYY-MM-DD")
          console.log("获取产品库存============>>",result);
        });
      },
      // err => {
      //   // console.log(err);
      //   this.$message({
      //     type: "error",
      //     message: err
      //   });
      // }
    );
  },
  created() {
    if (JSON.parse(localStorage.getItem("stkMessage"))) {
      //判断用户是否已登录
      //获取用户id
      this.userId = JSON.parse(localStorage.getItem("stkMessage")).id;
      console.log(this.userId, "this.userId");
    }
  }
};
</script>

<style lang="less" scoped>
@import "./style/main";
body {
  font-size: 14px;
}
.product-box {
  background: #fff;
  padding: 20px 40px;
  color: #666666;
  line-height: 30px;
  font-size: 14px;
  .product-content-box {
    border-top: 1px solid #e2e2e2;
    padding: 10px 0;
    color: #333;
  }
  .product-box-top {
    border-top: 0;
  }
}

.product-name {
  font-size: 24px;
  margin-bottom: 20px;
  line-height: 34px;
}

.product-label {
  font-weight: bold;
  margin: 20px 0 10px;
  color: #666;
}

.top-btn-box {
  margin-bottom: 15px;
  margin-top: 15px;
}

.product-box-center {
  a {
    color: @common-blue;
  }
  div > span {
    display: inline-block;
  }
  div > span:first-child {
    color: #666;
    width: 84px;
  }
  div > span:last-child {
    width: calc(100% - 90px);
  }
}

.label-box div > span {
  display: inline-block;
}

.label-box div > span:first-child {
  color: #666;
  width: 40%;
}

.label-box div > span:last-child {
  color: #333;
  width: 58%;
}

.product-half-content > div {
  width: 48%;
  position: relative;
}

.product-half-content > div:first-child::after {
  content: "";
  display: block;
  height: 80%;
  position: absolute;
  top: 15%;
  right: 0;
  border-right: 1px solid #e2e2e2;
}

.flex-box > .flex-item:first-child {
  width: 45% !important;
}

.product-left-font {
  width: calc(100% - 550px);
}

.product-left-label {
  width: 80px;
}

.product-left-label + div {
  width: calc(100% - 95px);
}

.sum-font {
  font-size: 16px;
  font-weight: bold;
  color: @common-blue;
}

.linkType {
  cursor: pointer;
  color: @common-blue;
}

.linkType:hover {
  text-decoration: underline;
  color: @common-blue;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/goods/ProductDetail.vue